import styled from 'styled-components'

interface Colors {
  color?: string
  isDataTask?: boolean
  dataSize: boolean
}

export const Container = styled.div<Colors>`
  background: #ffffff;

  a {
    color: #191b1c;
  }

  width: 100%;
  min-height: ${(props) => (props.dataSize ? '100px' : 0)};
  height: 100%;
  padding: 0.8rem;

  border-radius: 10px;
  border: 1px solid #cccccc;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${(props) => (props.dataSize ? '0.4rem' : 0)};

    a {
      color: black;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
  }

  .divider {
    height: 1px;
    background: #eeeeee;
    margin: 0.5rem 0;
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;

    h4,
    a {
      color: ${(props) => props.color};
      margin-bottom: 0;
    }
  }

  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    padding: 0;
  }

  transition: 0.3s;

  &:hover {
    border-radius: 15px;
    cursor: pointer;
  }
`
